var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"mb-2",attrs:{"height":"86","flat":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('HeaderTop'),_c('HeaderBottom')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }